import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {
  static targets = ["fileInput"]

  connect() {
    console.log("✅ Form controller connected to:", this.element)
    console.log("📁 File input targets found:", this.hasFileInputTarget)
  }

  fileInputTargetConnected(element) {
    console.log("📎 File input target connected:", element)
  }

  handleFileChange(event) {
    console.log("🔥 File input changed!", event.target.files)
    console.log("📤 Submitting form...")

    if (this.element && this.element.tagName === "FORM") {
      console.log("✅ Form found, submitting...")
      this.element.requestSubmit()
    } else {
      console.error("❌ Element is not a form!", this.element)
    }
  }
}
